<template>
  <component :is="componente"></component>
</template>

<script>
import PedidosLista from "@/views/pedidos/PedidosLista";
import PedidosClientesLista from "@/views/pedidos/PedidosClientesLista";

  export default {
    name: 'PedidosRedirect',
    components: {
      PedidosClientesLista,
      PedidosLista
    },
    data () {
      return {
        user: {},
        componente: 'PedidosLista',
        rodada: {},
      }
    },
    mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));
      this.rodada = JSON.parse(localStorage.getItem("rodada")) || [];

      if (this.rodada.id) {
        this.componente = 'PedidosLista';
      } else {
        if (this.user.tipo == 'representante' || this.user.tipo == 'cliente') {
          this.componente = 'PedidosClientesLista';
        } else {
          this.componente = 'PedidosLista';
        }
      }

    },
  }
</script>

<style>
</style>